import { render, staticRenderFns } from "./outbound-fax-completed-icon.vue?vue&type=template&id=6135144c"
import script from "./outbound-fax-completed-icon.vue?vue&type=script&lang=js"
export * from "./outbound-fax-completed-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6135144c')) {
      api.createRecord('6135144c', component.options)
    } else {
      api.reload('6135144c', component.options)
    }
    module.hot.accept("./outbound-fax-completed-icon.vue?vue&type=template&id=6135144c", function () {
      api.rerender('6135144c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/outbound-fax-completed-icon.vue"
export default component.exports